/**
 * O SIMBOLO DA MARCA em React: o monograma "LB" do Lu Barros Studio, o mesmo desenho de
 * `logo/simbolo.svg`.
 *
 * DIVERGENCIA LOCAL DO STUDIOLU (ver packages/ORIGEM.md): na plataforma este arquivo desenha o
 * simbolo da Complexity, transcrito de um PDF em curvas. Aqui a MESMA assinatura de componente
 * (`Simbolo({ className })`) desenha a marca Lu Barros, e e isso que deixa `Rail.tsx` e
 * `TelaLogin.tsx` intocados: eles importam `Simbolo` e nao sabem qual marca ele desenha.
 *
 * DE ONDE VEM O DESENHO: letras, italico, peso 500 e proporcao sao as do favicon que o painel
 * legado publica (`portal/admin.html:17`); as duas cores vem do logotipo (`site/logo.jpg`), com
 * o L em tinta e o B no taupe do arco.
 *
 * ELE NASCE DECORATIVO (`aria-hidden`): o uso dominante e ao lado do nome ESCRITO, e com rotulo
 * proprio o leitor de tela anunciaria a marca duas vezes seguidas.
 *
 * A COR VEM DE FORA, E SO DE FORA: `currentColor` no L e `--cx-marca-brilho` no B. Nenhum hex,
 * e e isso que faz o simbolo acompanhar tema claro e escuro sem duplicar arquivo.
 */
export function Simbolo({ className = '' }: { readonly className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="32"
        y="43"
        // A fonte e o token da marca, e nao o nome escrito aqui: trocar a fonte da identidade
        // vira edicao de uma linha em tokens.css, como o resto da tipografia.
        style={{ fontFamily: 'var(--cx-fonte-marca)' }}
        fontStyle="italic"
        fontWeight={500}
        fontSize={32}
        textAnchor="middle"
      >
        {/* O L na cor de quem usa (`text-marca` no rail e no login). */}
        <tspan fill="currentColor">L</tspan>
        {/* O B no taupe do logotipo; sem o token, cai para a cor do L em vez de sumir. */}
        <tspan fill="var(--cx-marca-brilho, currentColor)">B</tspan>
      </text>
    </svg>
  );
}
